(ns app.front.view.admin.commands.repair-cancelled-visit-booking
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::repair
  (fn [_ [_ booking-id]]
    {:comm/command {:command :admin/repair-cancelled-visit-booking
                    :method  :post
                    :data    {:booking-id booking-id}
                    :notify  {:success "Booking restored to fulfilled"}}}))

(defn repair-form [{:keys [initial-booking-id on-repair tr]}]
  (r/with-let [*booking-id (r/atom initial-booking-id)]
    [:div
     [:section
      [ui/help
       "Restore a booking that was fulfilled before a later inspection visit cancellation redispatched it."]
      [:div.flex.items-end.gap-4.mt-4
       [:div.w-1-3
        [ui/number-input {:id         "cancelled-visit-booking-id"
                          :light      true
                          :value      @*booking-id
                          :on-change  #(reset! *booking-id (-> % futil/tval parse-long))
                          :label-text "Booking entity ID"}]]
       [ui/modal-confirmation-button
        {:trigger-button-opts {:kind     :danger
                               :disabled (not (number? @*booking-id))
                               :size     :field}
         :trigger-button-text "Restore booking to fulfilled"
         :on-yes-click        #(on-repair @*booking-id)
         :tr                  tr
         :id                  "repair-cancelled-visit-booking"}
        [:div
         (str "Restore booking " @*booking-id
              " to fulfilled? This only succeeds when an inspection visit cancellation redispatched the booking.")]]]]]))

(defn view [match]
  (let [tr (<sub [:tr])]
    [acommon/admin-page-v2
     (util/mmap {:title "Repair cancelled inspection visit booking"} match)
     [repair-form {:tr        tr
                   :on-repair #(>evt [::repair %])}]]))

(def route
  {:name        :view/admin.commands.repair-cancelled-visit-booking
   :own-layout? true
   :view        view})
